import React from 'react'
import Button from './Button'

// eslint-disable-next-line react/display-name
export default ({ ...props }) => {
  return <Button {...props} />
}
